"use client";
import { FeedPostAuthor } from "../FeedPostAuthor";
import { FeedPostDtoWithOgMetadata } from "@/api/posts/types";
import { FeedOptions } from "../FeedOptions";
import { FeedPostGallery } from "@/app/(components)/Basic/FeedPostGallery";
import React from "react";
import Linkify from "linkify-react";
import { FeedOgContent } from "../FeedOgContent";
import { NewsFeedPortal } from "../NewsFeed/NewsFeedPortal";

export interface Props {
  feedPost: FeedPostDtoWithOgMetadata;
  hideActions?: boolean;
  className?: string;
  showAttachedNftLinks?: boolean;
  forceLightTheme?: boolean;
}

function FeedPostContent({
  feedPost,
  hideActions = false,
  className,
  showAttachedNftLinks = true,
  forceLightTheme,
}: Props) {
  const showOgMetadata =
    !feedPost.attachedNft &&
    !feedPost.repost &&
    !feedPost.gallery?.length &&
    feedPost.ogMetadata;

  return (
    <div className={className}>
      <div className="flex flex-row justify-between mb-2 md:mb-1">
        {feedPost.author ? (
          <FeedPostAuthor
            feedPost={feedPost}
            forceLightTheme={forceLightTheme}
          />
        ) : feedPost.portalMetadata ? (
          <NewsFeedPortal feedPost={feedPost} />
        ) : null}
        {!hideActions && <FeedOptions feedPost={feedPost} />}
      </div>
      <div className="flex flex-col items-start mb-2 md:mb-4 whitespace-pre-line">
        <Linkify
          options={{
            className: "text-red endemic:text-yellow",
            target: "_blank",
          }}
        >
          {feedPost.artOrderId ? (
            <div
              dangerouslySetInnerHTML={{
                __html: feedPost.text!,
              }}
              className="text-body-3 leading-[22px] mb-2 md:mb-4 whitespace-pre-line mt-4"
            />
          ) : (
            <p className="text-body-3 leading-[22px]">{feedPost.text}</p>
          )}
        </Linkify>
      </div>

      <FeedPostGallery
        images={feedPost.gallery}
        nft={feedPost.attachedNft}
        className={"hidden lg:flex"}
        showLinks={showAttachedNftLinks}
        forceLightTheme={forceLightTheme}
      />

      <FeedPostGallery
        images={feedPost.gallery}
        nft={feedPost.attachedNft}
        className="flex lg:hidden"
        maxNumberOfImages={2}
        showLinks={showAttachedNftLinks}
        forceLightTheme={forceLightTheme}
      />

      {showOgMetadata && <FeedOgContent metadata={feedPost.ogMetadata!} />}
    </div>
  );
}

export default React.memo(FeedPostContent);
